import PropTypes from "prop-types";
import { Icono } from "../../components/ui/Iconos";
import { mensajeSimple } from "../../components/ui/sweetAlerts";

export const OpcionesCambioCards = ({ uno, modulo, hideModal }) => {
  if (uno === undefined) return null;

  const esContratoIndefinido = ["01"].includes(uno["REEO_TIPO_CONTRATO"]);

  return (
    <div className="col col-11 col-lg-10 col-xl-10">
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-2 row-cols-xxl-4 g-3">
        {["3"].includes(modulo) ? (
          <div className="w-100 d-flex justify-content-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-3">
              <button
                className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer",
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                }}
                onClick={() => hideModal(5)}
              >
                <Icono iconName="desvinculacion" />
                <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                  Iniciar desvinculación
                </span>
              </button>
            </div>
          </div>
        ) : (
          <>
            {/* Opción 1: Cambio de Cargo */}
            <div className="col">
              <button
                className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100 w-100"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer",
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                }}
                onClick={() => hideModal(1)}
              >
                <Icono iconName="cambioCargo" />
                <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                  Cambio de Cargo (SAP & Temporis)
                </span>
              </button>
            </div>

            {/* Opción 2: Cambio de Unidad */}
            <div className="col">
              <button
                className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100 w-100"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer",
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                }}
                onClick={() => hideModal(2)}
              >
                <Icono iconName="cambioUnidad" />
                <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                  Cambio de Unidad (Temporis)
                </span>
              </button>
            </div>

            {/* Opción 3: Cambio de Instalación */}
            <div className="col">
              <button
                className="card-opcion bg-white p-3 d-flex align-items-center gap-3 h-100 w-100"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer",
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                }}
                onClick={() => hideModal(3)}
              >
                <Icono iconName="cambioInstalacion" />
                <span className="fw-bold" style={{ fontSize: "13.5px", color: "#2d3748", lineHeight: "1.2" }}>
                  Cambio de Instalación
                </span>
              </button>
            </div>

            {/* Opción 4: Actualización Estatus */}
            <div className="col">
              <button
                className={`card-opcion p-3 d-flex align-items-center gap-3 h-100 w-100 ${
                  esContratoIndefinido ? "card-opcion-disabled" : "bg-white"
                }`}
                style={{
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e2e8f0",
                  cursor: esContratoIndefinido ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (esContratoIndefinido) {
                    mensajeSimple("info", "Este colaborador(a) posee Contrato Indefinido", 2300);
                    return;
                  }
                  hideModal(4);
                }}
              >
                <Icono iconName="cambioEstatus" color={esContratoIndefinido ? "#9E9E9E" : "#1877F2"} />
                <div className="d-flex flex-column gap-1">
                  <span
                    className="fw-bold"
                    style={{
                      fontSize: "13.5px",
                      color: esContratoIndefinido ? "#64748b" : "#2d3748",
                      lineHeight: "1.25",
                    }}
                  >
                    Estatus contrato de trabajo
                    <br />
                    (Renovación Plazo Fijo e Indefinido)
                  </span>
                  {esContratoIndefinido && (
                    <span
                      style={{
                        backgroundColor: "#e2e8f0",
                        color: "#475569",
                        border: "1px solid #cbd5e1",
                        borderRadius: "4px",
                        fontSize: "11px",
                        fontWeight: "600",
                        padding: "2px 8px",
                        width: "fit-content",
                      }}
                    >
                      No disponible
                    </span>
                  )}
                </div>
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

OpcionesCambioCards.propTypes = {
  uno: PropTypes.object,
  modulo: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
};
